import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/tabela-obm`

    return {
        show(id) {
            return repository.get(`${baseUrl}/${id}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        datatable(queryParms = {}) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
    }
}